import { Public } from '@mui/icons-material';
import { Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

export const ManufacturingLocations = ({ presenceCountries, size = 'md' }) => {
  const { t } = useTranslation(['my-companies']);
  const hasPresenceCountries =
    presenceCountries && presenceCountries.length > 0;

  const joinedPresenceCountriesLimitedBy2 = hasPresenceCountries
    ? presenceCountries
        .slice(0, 2)
        .map((c) => c.name)
        .join(', ')
    : null;

  const joinedPresenceCountries = hasPresenceCountries
    ? presenceCountries.map((c) => c.name).join(', ')
    : null;

  const restCountriesCount = presenceCountries.length - 2;

  if (hasPresenceCountries) {
    return (
      <Tooltip title={joinedPresenceCountries} arrow>
        <Typography
          variant={size === 'md' ? 'body1' : 'caption'}
          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
          color="textSecondary"
        >
          <Public fontSize="small" />{' '}
          {`${joinedPresenceCountriesLimitedBy2}${
            presenceCountries.length > 2 ? `, +${restCountriesCount}` : ''
          }`}
        </Typography>
      </Tooltip>
    );
  }

  return null;
};
